import React, { useState, useEffect } from "react";
import instance from "../../api/api";
// import { Steps } from "antd";
import { Help } from "../../utils";
import { ProgressSpinner } from "primereact/progressspinner";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate } from "react-router-dom";
import { DetailsFactures } from "../Facture/FactureDetail";
import { FaArrowLeft } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Header, LoadingSpinner, InfoDetails } from "../../shared/compoments";

const InfoLocataire = ({ locataire, locataireEmail, locatairePhone }) => {
  return (
    <div>
      <h4 className="badge bg-dark">Info Locataire</h4>
      <div>
        <div>
          <span className="text-secondary">Locataire : </span> {locataire}
        </div>
        <div>
          <span className="text-secondary">Contacts : </span>{" "}
          <div>
            <p className="m-0 p-0">{locatairePhone}</p>
            <p className="m-0 p-0">{locataireEmail}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const InfoPaiement = ({
  Montant,
  moyensPaiement,
  MontantRestant,
  MontantRendu,
  Transactions,
  Date,
}) => {
  return (
    <div>
      <h4 className="badge bg-warning">Info Paiement</h4>
      <div>
        <p>
          <span className="text-secondary">Date : </span> {Date}
        </p>
        <p>
          <span className="text-secondary">Transactions : </span> {Transactions}
        </p>
        <p>
          <span className="text-secondary">Montant reçu : </span>
          {Help.convertInMoney(Montant)} Fcfa
        </p>
        <p>
          <span className="text-secondary">Moyens paiement : </span>{" "}
          {moyensPaiement}
        </p>

        <p>
          <span className="text-secondary">Montant restant : </span>{" "}
          {Help.convertInMoney(MontantRestant)} Fcfa
        </p>
        {MontantRendu && (
          <p>
            <span className="text-secondary">Montant rendu : </span>{" "}
            {Help.convertInMoney(MontantRendu)} Fcfa
          </p>
        )}
      </div>
    </div>
  );
};

function DetailCommandes() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [dataDetailPayement, setDataDetailPayement] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [detailInfo, setDetailInfo] = useState([]);
  // const [visible, setVisible] = useState(false);
  const dataInfoDetail = (
    created_at,
    amount_paid,
    amount_left,
    channel,
    monai_rendu,
    reference,
    date_debut,
    date_fin,
    operateur
  ) => {
    const element = [];
    element.push(
      { title: "NUMÉRO DE LA FACTURE", value: reference },
      {
        title: "DATE DE PAIEMENT",
        value: new Date(created_at).toLocaleDateString("fr"),
      },
      {
        title: "MONTANT REÇU",
        value: `${Help.convertInMoney(amount_paid)} Fcfa`,
      },
      { title: "MOYEN DE PAIEMENT", value: channel },
      { title: "OPERATEUR MOBILE", value: operateur },
      {
        title: "MONTANT RESTANT",
        value: `${Help.convertInMoney(amount_left)} Fcfa`,
      },
      {
        title: "MONTANT RENDU ",
        value: `${Help.convertInMoney(monai_rendu)} Fcfa`,
      },
      {
        title: "PAYER POUR LA PÉRIODE DU:",
        value: `${new Date(date_debut).toLocaleDateString("fr")} au ${new Date(date_fin).toLocaleDateString("fr")}`,
      }
    );
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };

  // async function handleColi(value) {
  //   setIsCommande(true);
  //   const data = {
  //     statut: value,
  //     date_livraison:
  //       value === "annulée"
  //         ? null
  //         : value === "confirmer"
  //         ? null
  //         : dateLivraison,
  //     commentaire: value === "annulée" ? dataCommentaire : null,
  //   };
  //   console.log("DATA", data);
  //   try {
  //     const response = await instance.put(
  //       `/commandes/${dataDetailPayement.id}`,
  //       data
  //     );
  //     console.log("response", response.data);
  //     dataDetailPayement.statut = value;
  //     dataDetailPayement.date_livraison = dateLivraison;
  //     console.log("dataDetailPayement.statut", dataDetailPayement.statut);
  //     if (response.data.status === true) {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setVisible(false);
  //       setIsCommande(false);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setIsCommande(false);
  //   }
  // }
  // const preparerColis = () => {
  //   console.log("preparerColis");
  //   handleColi("en cours");
  // };
  // const annulerColis = () => {
  //   console.log("annulee");
  //   handleColi("annulée");
  // };
  // const livrerColis = () => {
  //   console.log("livree");
  //   handleColi("livrée");
  // };
  // const confirmerColis = () => {
  //   handleColi("Confirmer");
  // };
  // const sendColis = (value) => {
  //   switch (value) {
  //     case "preparer":
  //       preparerColis();
  //       break;
  //     case "annuler":
  //       annulerColis();
  //       break;
  //     case "livrer":
  //       livrerColis();
  //       break;
  //     case "confirmer":
  //       confirmerColis();
  //       break;
  //     default:
  //       console.log("send");
  //       break;
  //   }
  // };

  useEffect(() => {
    const getDetailPaiements = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get(`/payments/${id}`);
        console.log("getDetailPaiements", response?.data?.data);
        const {
          created_at,
          amount_paid,
          amount_left,
          channel,
          monai_rendu,
          facture: { reference, date_debut, date_fin },
          operateur,
        } = response.data.data;
        dataInfoDetail(
          created_at,
          amount_paid,
          amount_left,
          channel,
          monai_rendu,
          reference,
          date_debut,
          date_fin,
          operateur
        );
        setDataDetailPayement(response?.data?.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getDetailPaiements();
  }, [id]);

  if (isLoading) return <LoadingSpinner />;
  return (
    <div>
      {/* <Dialog
        header="Raison"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          className="w-100"
          onChange={(e) => setDataCommentaire(e.target.value)}
        ></textarea>
        <button
          className="btn bg-danger mx-2 text-light"
          onClick={() => sendColis("annuler")}
        >
          {!isCommande ? (
            "Confirmer"
          ) : (
            <ProgressSpinner
              style={{ width: "25px", height: "25px" }}
              strokeWidth="5"
              animationDuration=".5s"
            />
          )}
        </button>
      </Dialog> */}
      <Header libelle={"Détails de paiement"} isReturn />

      <InfoDetails
        namePerson={`${dataDetailPayement?.facture.contract.client.nom} ${dataDetailPayement?.facture.contract.client.prenom}`}
        detailPhone={dataDetailPayement?.facture.contract.client.phone}
        detailAdresse={dataDetailPayement?.facture.contract.client.adresse}
        detailEmail={dataDetailPayement?.facture.contract.client.email}
        titleInfo={`Paiement ${dataDetailPayement?.trans_id}`}
        widthBody={"73%"}
        dataInfo={detailInfo}
        dataBtnWithOptions={[]}
      />
      {/* <span
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <FaArrowLeft fontSize={"2em"} />
      </span>
      <h3 className="my-4 text-start">
        Détail du paiement:
        {dataDetailPayement && dataDetailPayement.trans_id}
      </h3> */}
      {/* {dataDetailPayement && (
        <>
          <div>
            <InfoPaiement
              Montant={dataDetailPayement.amount_paid}
              moyensPaiement={dataDetailPayement.channel}
              MontantRestant={dataDetailPayement.amount_left}
              MontantRendu={dataDetailPayement.monai_rendu}
              Transactions={dataDetailPayement.trans_id}
              Date={new Date(dataDetailPayement.created_at).toLocaleDateString(
                "fr"
              )}
            />
             <hr />
            <DetailsFactures
            detailDate={dataDetailPayement?.facture.created_at}
            detailReference={dataDetailPayement?.facture.reference}
            detailPeriode={{
              date_debut: dataDetailPayement?.facture.date_debut,
              date_fin: dataDetailPayement?.facture.date_fin,
            }}
            detailMontant={dataDetailPayement?.facture.cost}
            detailType={dataDetailPayement?.facture.type}
            detailStatut={dataDetailPayement?.facture.statut}
            showPrint={false}
          />
            <hr />
            <InfoLocataire
              locataire={`${dataDetailPayement?.facture.contract.client.nom} ${dataDetailPayement?.facture.contract.client.prenom}`}
              locataireEmail={dataDetailPayement?.facture.contract.client.email}
              locatairePhone={dataDetailPayement?.facture.contract.client.phone}
            />
          </div>
        </>
      )} */}
    </div>
  );
}

export default DetailCommandes;
